import Button from "components/common/Button";
import ExportButton from "components/common/Export";
import { exportURLs } from "components/common/Export/ExportAPIEndpoints";
import BasicTable from "components/common/Table";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { PAGE_SIZE } from "utils/CommonConstants";
import { serviceTypes } from "utils/Types";
import { routes } from "utils/routes";
import { fetchFeedbackForms, fetchFeedbackFormsQuestionsCategories } from "./Feedback.slice";
import { headers } from "./TableHeadersConfig";
import ViewFeedback from "./ViewFeedback";
import "./index.scss";

export default function Feedback() {
  const translate = useTranslate();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const feedbackForms = useAppSelector((state) => state?.feedback?.feedbackForms?.forms);
  const totalRecords = useAppSelector((state) => state?.feedback?.feedbackForms?.meta?.page?.total);
  const sorting = useAppSelector((state) => state.sortingDetails.sorting);
  const manageFeedbackAccess = useAppSelector((state) => state.app.loggedInUserDetails.manageFeedbackAccess);
  const recentSortingApplied = sorting?.["feedbackForms"];
  const questionCategories = useAppSelector((state) => state.feedback.questionCategories.list);

  const [pageNo, setPageNo] = useState(0);
  const [formId, setFormId] = useState<boolean | null>(null);

  useEffect(() => {
    dispatch(fetchFeedbackForms({ page: 0, size: PAGE_SIZE, sort: Object.values(recentSortingApplied).join(",") }));
    setPageNo(0);
  }, [recentSortingApplied]);

  useEffect(() => {
    if (pageNo > 0) {
      dispatch(
        fetchFeedbackForms({ page: pageNo, size: PAGE_SIZE, sort: Object.values(recentSortingApplied).join(",") })
      );
    }
  }, [pageNo]);

  useEffect(() => {
    if (!questionCategories.length) dispatch(fetchFeedbackFormsQuestionsCategories());
  }, []);

  return (
    <>
      {!formId ? (
        <div className="feedback-container">
          <div className="page-title-container">
            <Typography variant={"h3"} showBold color={tokens.Icon.General.Primary}>
              {translate("feedback.header")}
            </Typography>
          </div>
          <div id="feedback-container" className="feedback-box">
            <div className="feedback-table">
              <div className="feedback-header">
                <ExportButton
                  isDateRangeApplicable
                  isGet
                  label="Export Feedback Report"
                  URL={exportURLs.feedback}
                  serviceType={serviceTypes.userplan}
                />
              </div>
              <BasicTable
                scrollableTarget="feedback-container"
                isTablePaginated={true}
                customPaginationType="forms"
                totalRecords={totalRecords}
                pagination={{ pageNo: pageNo, setPageNo: setPageNo }}
                noDataMessage={translate("feedback.noFeedbackFormsFound")}
                tableName="feedbackForms"
                data={{
                  headers: headers,
                  rows: feedbackForms?.map((element: any) => ({
                    data: [
                      {
                        content: (
                          <Typography variant="body2" showBold>
                            {element.type}
                          </Typography>
                        )
                      },
                      { content: element.triggerPoint },
                      { content: element.numberOfQuestions },

                      {
                        content:
                          manageFeedbackAccess !== "View" ? (
                            <Button
                              height="34px"
                              width="100px"
                              variant="secondary"
                              label="Edit Form"
                              onClick={() => navigate(`${routes.EditFeedback}/${element.id}`)}
                            />
                          ) : (
                            <Button
                              height="34px"
                              width="100px"
                              variant="secondary"
                              label="View Form"
                              onClick={() => {
                                setFormId(element.id);
                              }}
                            />
                          ),
                        contentAlignment: "flex-end"
                      }
                    ]
                  }))
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <ViewFeedback formId={formId} setFormId={setFormId} />
      )}
    </>
  );
}
